<div class="absolute z-50 h-fit w-full">
    <ng-container *ngFor="let alertMessage of alertMessages">
        <fuse-alert [appearance]="'outline'" dismissible="true" (afterDismissed)="removeMessage(alertMessage)" [dismissed]="alertMessage.dismissed"  [type]="alertMessage.type">
            <span fuseAlertTitle class="text-xl">{{(alertMessage.title)}}</span>
            <div class="text-lg">{{alertMessage.message}}</div>
        </fuse-alert>
    </ng-container>
    
</div>